module.exports = __webpack_public_path__ + "media/images/home/upcoming-event-bg-mobile-fee1f7bb00d770cb20bc157731878808.png";